import React from 'react';

import { Link } from '@material-ui/core';
import styled from 'styled-components';
import { NewStyledIconContainer, StyledGrid, StyledTypography, StyledBox } from 'styles/common';

import { DownloadIcon, PDFFileIcon } from 'constants/icons';

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const HelpCard = styled(StyledBox)`
  padding: 1.5rem 0.75rem 0.5rem 0.75rem;
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
  margin-right: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${(props) => (props.fullWidth ? '100%' : '25%')};
  border: ${(props) => `1px solid ${props.theme.palette.borders.lightGrey}`};
  border-radius: 4px;
`;
export const FileCardComp = ({ title, downloadLink, fullWidth = false, onDownloadHandler = () => {} }) => (
  <HelpCard fullWidth={fullWidth}>
    <StyledGrid container wrap="nowrap">
      <NewStyledIconContainer size="small" color="primary">
        <PDFFileIcon />
      </NewStyledIconContainer>
      <StyledTypography variant="body2" color="textPrimary" leftGutter={2} rightGutter={1}>
        {title}
      </StyledTypography>
    </StyledGrid>
    <StyledGrid container justify="flex-end" alignItems="center">
      <StyledLink target="_blank" href={downloadLink} underline="none" onClick={onDownloadHandler}>
        <DownloadIcon rightGutter={0.5} size="tiny" color="textSecondary" />
        <StyledTypography variant="subtitle2" color="textSecondary">
          Download
        </StyledTypography>
      </StyledLink>
    </StyledGrid>
  </HelpCard>
);
